<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow, }"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="common-modal-close" style="position:absolute;top: -14px;right:-14px;"  @click="onModalClose">
                    <img  class="connect_close" src="https://resource.rcclchina.com.cn/cruiseDetail/pc/connect_close.png" alt="">
                </div>

                <div class="modal-body">
                    <img src="https://resource.rcclchina.com.cn/connectRoom/connect_pop.jpg"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConnectRoomPopup",
    props: {
        isShow: {
            type: Boolean
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal {
    overflow-y: auto;
    .modal-content {
        padding: 0px;
        background: transparent;
        box-shadow: none;
        border: none;
    }
}
.modal-body {
    padding: 0px;
    img {
        width: 100%;
    }
}
.modal-dialog {
    top: 15%;
    width: 749px !important;
}

.modal.active {
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>